export default {
	loadDefaultProviders: ['thunderwaveServer'],
	loadDefaultPlugins: ['defaultPack']
};
